import { createContext, useContext } from 'react';

/**
 * True for everything drawn BEHIND an open Post sheet (the background route tree in
 * `PostSheetOutlet`). A background screen is mounted under a URL that is not its own: the router's
 * current entry is the sheet's, so a background `navigate(..., { replace: true })` or
 * `setSearchParams` would overwrite the sheet's entry and drop the sheet. A screen that redirects
 * or rewrites its URL on mount waits while this is true (`useOnboardingEntryRedirect`,
 * `useReflectInviteToken`, and CommunityDetail's `?tab=` drop, `?event=` and canonical-slug
 * redirects do); it runs once the sheet closes and its own URL is current again.
 */
export const PostSheetBackgroundContext = createContext(false);

export function useIsBehindPostSheet(): boolean {
  return useContext(PostSheetBackgroundContext);
}
